/**
 * Created by asi on 23/09/19.
 */
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router} from "@angular/router";
import { UserStore } from "@digicerba/common";

@Injectable()
export class FormationsAdminGuard implements CanActivate {

  constructor(private userStore: UserStore, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    if (this.userStore.isAdmin()) {
      return true;
    }
    else {
      this.router.navigate(['']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/formations-admin-guard.ts